<template>
  <b-row>
    <b-col
      cols="12"
      xl="10"
      class="mb-3"
    >
      <b-card no-body>
        <h4 class="m-2">
          {{ $t('settings.invoices.title') }}
        </h4>

        <rc-overlay :show="loading">
          <b-table
            :key="`${queryParams.currentPage}-settlements-list`"
            ref="refSettlementListTable"
            primary-key="id"
            responsive
            :items="list"
            :fields="tableColumns"
            :per-page="queryParams.perPage"
            class="position-relative"
            show-empty
            :empty-text="loading ? '' : $t('shared.no-data')"
          >

            <!-- Column: invoiceNumber -->
            <template #cell(invoiceNumber)="data">
              <strong>
                {{ data.item.invoiceNumber }}
              </strong>
            </template>

            <!-- Column: invoiceDate -->
            <template #cell(invoiceDate)="data">
              {{ transformDateToHumanReadablePretty(data.item.invoiceDate) }}
            </template>

            <!-- Column: value -->
            <template #cell(value)="data">
              {{ data.item.value / 100 }} zł
            </template>

            <!-- Column: Actions -->
            <template #cell(actions)="data">
              <b-button
                variant="flat-primary"
                @click="downloadInvoice(data.item.id)"
              >
                <feather-icon
                  icon="DownloadIcon"
                  size="14"
                  class="mr-25"
                />
              </b-button>
            </template>

          </b-table>
        </rc-overlay>

        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('shared.pagination-summary', dataMeta) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-if="totalItems > queryParams.perPage"
                v-model="queryParams.page"
                :total-rows="totalItems"
                :per-page="queryParams.perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import invoicesSettingsTabSetup from '@/views/organization/settings/plan-and-billing/tabs/invoicesSettingsTabSetup'
import RcOverlay from '@/layouts/components/rc/RcOverlay.vue'

export default {
  components: {
    BButton,
    RcOverlay,
  },
  setup: invoicesSettingsTabSetup,
}
</script>

<style scoped>

</style>
